import * as ScratchBlocks from 'scratch-blocks';
import {costumeUpload, spriteUpload} from './file-uploader';

export const requestGeneratedImage = kind => {
    window.dispatchEvent(new CustomEvent('scratch-cg:generate-image', {detail: {kind}}));
};

export const importGeneratedImage = (vm, kind, bytes, name, targetId) => new Promise((resolve, reject) => {
    const storage = vm.runtime.storage;
    const data = bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength);
    const fail = () => reject(new Error('IMAGE_IMPORT_FAILED'));
    if (kind === 'sprite') {
        spriteUpload(data, 'image/png', name, storage, sprite => {
            vm.addSprite(sprite).then(resolve, reject);
        }, fail);
        return;
    }
    costumeUpload(data, 'image/png', storage, costumes => {
        const costume = {...costumes[0], name};
        const operation = kind === 'backdrop' ?
            vm.addBackdrop(costume.md5, costume) :
            vm.addCostume(costume.md5, costume, targetId);
        operation.then(resolve, reject);
    }, fail);
});

export const undoEditorBlocks = redo => {
    const workspace = ScratchBlocks.getMainWorkspace();
    if (workspace) workspace.undo(redo);
};
